import './thumbs-slider.scss';

$('.thumbs-slider').each(function () {
    let $slider = $(this);

    new window.Swiper($slider.get(0), {
        slidesPerView: 'auto',
        navigation: {
            prevEl: $slider.find('.swiper-button-prev'),
            nextEl: $slider.find('.swiper-button-next')
        },
        pagination: {
            el: $slider.find('.swiper-pagination')
        }
    });
});